import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.canvas.images');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-nrich-canvas-images',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichCanvasImagesComponent implements OnInit, OnChanges {
    @Input() documentId: string = '';
    @Input() pdfName: string = '';
    @Input() currentPage: number = 1;

    public images: any[] = [];
    public kgByImage: any = {};
    public loading: boolean = true;
    public error: string = '';
    public lightboxSrc: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.documentId && this.currentPage) {
            await this.loadImages();
        }
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if ((changes['currentPage'] || changes['documentId']) && this.documentId) {
            await this.loadImages();
        }
    }

    private async loadImages() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('page_images', {
                document_id: this.documentId,
                page: this.currentPage,
            });
            if (code === 200) {
                this.images = data.images || [];
            } else {
                this.images = [];
            }

            // KG 엔터티 조회
            this.kgByImage = {};
            try {
                const kgRes = await wiz.call('kg_entities', {
                    document_id: this.documentId,
                    entity_type: 'image',
                });
                if (kgRes.code === 200) {
                    for (const e of (kgRes.data.entities || [])) {
                        if (e.image_id) {
                            this.kgByImage[e.image_id] = e;
                        }
                    }
                }
            } catch { /* KG 없어도 이미지는 표시 */ }
        } catch (e: any) {
            this.error = '이미지 로드 실패';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public getImageUrl(img: any): string {
        return `/wiz/api/page.document.item/image?document_id=${encodeURIComponent(this.documentId)}&image_path=${encodeURIComponent(img.file_path || '')}`;
    }

    public getKgEntity(img: any): any {
        return this.kgByImage[img.id] || null;
    }

    public getPageStr(entity: any): string {
        const pages = entity.pages || [];
        return pages.map((p: any) => `${p.page}p`).join(', ') || '-';
    }

    public openLightbox(src: string) {
        this.lightboxSrc = src;
        this.service.render();
    }

    public closeLightbox() {
        this.lightboxSrc = '';
        this.service.render();
    }
}

export default PortalNrichCanvasImagesComponent;